import React, { useEffect, useState } from 'react'
import { BreadCrumbSecttion } from '../component/BreadCrumbSecttion'
import Footer from '../component/Footer'
import { Col, Row, Container } from 'react-bootstrap'
import OtherService from '../services/Other'
import PrimaryGradientButton from '../component/PrimaryGradientButton';
import { Link, useNavigate } from 'react-router-dom'
import Loader from '../component/Loader'
import NoData from '../component/NoData'

const Gallery = () => {

 //All UseState
 const [loading, setLoading] = useState(true);
 const [noData, setNoData] = useState(false);
 const [isPhotoGallery, setIsPhotoGallery] = useState([]);
  //All useEffect
  useEffect(() => {
    const galleryFetchData = async () => {
      try {
        const token = localStorage.getItem('access_token');
        const galleryResponse = await OtherService.gallery(token);
        if(galleryResponse.error == false)
        { 
          if(galleryResponse.data.imageDetails.length > 0)
          {
            const imageDetails = galleryResponse.data.imageDetails;
            setIsPhotoGallery(imageDetails);
            setLoading(false)
            setNoData(false)
            
          }
          else{
            setLoading(false)
            setNoData(true)
          }
          
        }
        else{
          setLoading(false)
          setNoData(true)
        }
      }
      catch (error) {
        console.error('Error:');
      }

    }
    galleryFetchData()
  }, [])
  const navigate = useNavigate()
  //All Functions
  const handlePicItemDetails = (contentId) => {
    navigate(`/gallery-pic/${contentId}`);
 }
  return (
    <> 
      {/* {loading && <Loader/>} */}
      
      <BreadCrumbSecttion
        pageTitle="Gallery"
        currentPageName="Gallery"
      />
      <section className='padTop50'>
        <Container>
          <Row>
            <Col xs={12}>
              <div className='notificationTabList'>
                <ul>
                  <li className='active'>
                    <Link to="/gallery">Photo</Link>
                  </li>
                  <li>
                    <Link to="/video-gallery">Video</Link>
                  </li>
                  <li>
                    <Link to="/document-gallery">Document</Link>
                  </li>
                </ul>
              </div>
              <div className='userInfoBox'>
                
                  <div className="dashboard-details">
                  {noData && 
                    <Row>
                      <Col><NoData /></Col>
                    </Row>
                     }
                    <Row>

                      {isPhotoGallery.map((item) => {
                        const { contentDetails, files, index } = item;
                        return (
                          <Col xs={12} lg={3} key={index} className='galleryImgBox'>
                            <div className='itemWrap'>
                              <div className='itemWrapImage'>
                                
                              {files.length > 0 && (
                                  <img src={files[0].file_path} className='img-fluid'/>
                                )}
                                                    
                              </div>
                              <div className="itemWrapImageTxt"><p>{contentDetails.title}</p></div>
                              <PrimaryGradientButton buttonText="View More"  onClick={()=>handlePicItemDetails(contentDetails.id)}/>
                             </div>
                          </Col>
                        );
                      })}
                    </Row>
                  </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    

    </>
  )
}

export default Gallery